import React from 'react';

function formatCategoryName(name) {
    if (name === 'all') return 'Todos';
    return name.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

function CategoryFilter({ categories, selectedCategory, onSelectCategory }) {
    if (!categories || categories.length === 0) return null;

    return (
        // z-30 e sticky fazem ela grudar no topo da página
        <div className="sticky top-[64px] md:top-[80px] z-30 w-full bg-[#FFF5EE]/90 backdrop-blur-md border-y border-[#dbcdac]/30 py-3 md:py-4 shadow-sm">
            {/* overflow-x-auto permite rolar com o dedo no celular ocultando a scrollbar */}
            <div className="max-w-5xl mx-auto px-6 flex gap-3 overflow-x-auto scrollbar-hide snap-x">
                {categories.map((category) => {
                    const isActive = selectedCategory === category;
                    return (
                        <button
                            key={category}
                            onClick={() => onSelectCategory(category)}
                            className={`
                                snap-center shrink-0 px-5 py-2 rounded-full text-xs md:text-sm font-bold uppercase tracking-widest transition-all duration-300 border-2 whitespace-nowrap
                                ${isActive 
                                    ? 'bg-[#971253] border-[#971253] text-[#FFF5EE] shadow-md transform scale-105' 
                                    : 'bg-white border-[#dbcdac]/40 text-stone-500 hover:text-[#528a89] hover:border-[#528a89]/50'
                                }
                            `}
                        >
                            {formatCategoryName(category)}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export default CategoryFilter;